import AmexPlatinumReferAFriend from './AmexPlatinumReferAFriend';

export default AmexPlatinumReferAFriend;
